import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { CreateEventPayload } from "../repositories/eventsRepository";
import { eventsRepository } from "../repositories/eventsRepository";
import { invalidateSupplyPlanQueries } from "./useSupplyPlanQuery";

export const createEventMutationKey = ["event", "create"];

export function useCreateEventMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: createEventMutationKey,
    mutationFn: (data: CreateEventPayload) =>
      eventsRepository.createEvent(data),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["event", "upcoming"] });
      invalidateSupplyPlanQueries(queryClient, variables.terreiroId);
    },
  });
}
